import api from './api';

export interface VsixVersion {
  version: string;
  releasedOn: string;
  size: string;
  highlights: string;
  filename: string;
  latest?: boolean;
}

export interface VsixVersionsResponse {
  success: boolean;
  versions: VsixVersion[];
}

export const vsixService = {
  getVersions: async (): Promise<VsixVersionsResponse> => {
    const response = await api.get<VsixVersionsResponse>('/vsix/versions');
    return response.data;
  },

  downloadVsix: async (filename: string): Promise<Blob> => {
    const response = await api.get(`/vsix/download/${filename}`, {
      responseType: 'blob',
    });
    return response.data;
  },

  getDownloadUrl: (filename: string): string => {
    const token = localStorage.getItem('token');
    const baseURL = api.defaults.baseURL || '/api';
    return `${baseURL}/vsix/download/${filename}?token=${token}`;
  },
};
